import PropTypes from 'prop-types';
import React from 'react';
import { Popover } from 'react-bootstrap';
import { getLinksPopoverData } from '../AdjustmentGroup/AdjustmentGroupHelpers';
import { linkedAdjustmentsShape } from '../../../../../common/components/proptypes/commonProptypes';
import LinkedAdjustmentsSelectedItems from '../../../../linking/common/LinkedAdjustmentsEditor/LinkedAdjustmentsSelectedItems/LinkedAdjustmentsSelectedItems';
import './LinkedAdjustmentPopover.scss';

const LinkedAdjustmentPopover = React.forwardRef(
  ({ adjustmentLinks, projectId, ...props }, ref) => {
    const popoverData = getLinksPopoverData(adjustmentLinks);

    return (
      <Popover
        id="popover-linked-adjustments"
        ref={ref}
        data-testid="popover-linked-adjustments"
        {...props}
      >
        <Popover.Content className="popup-menu scrollable">
          <>
            <LinkedAdjustmentsSelectedItems
              projectId={projectId}
              selectedLinks={popoverData}
            />
          </>
        </Popover.Content>
      </Popover>
    );
  }
);

LinkedAdjustmentPopover.propTypes = {
  adjustmentLinks: PropTypes.arrayOf(linkedAdjustmentsShape),
  projectId: PropTypes.string.isRequired,
};

LinkedAdjustmentPopover.defaultProps = {
  adjustmentLinks: [],
};

export default LinkedAdjustmentPopover;
